import React, { useState } from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import StarBorder from "@mui/icons-material/StarBorder";
import Collapse from "@mui/material/Collapse";
//import { useNavigate } from "react-router-dom";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import TokenService from "../service/TokenService";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
function MenuAdmin({ handleNavigation }) {
    const [openutilities, setopenutilities] = useState(false);
    const handleClickopenutilities = () => {
      setopenutilities(!openutilities);
    };
  
    //const navigate = useNavigate();
  
    const tokenServiceDetails = TokenService.getUserDetails();
    const urights = tokenServiceDetails?.userrights;
  
    return (
      <List sx={{ bgcolor: "background.paper" }} component="nav">
        <ListItemButton onClick={handleClickopenutilities}>
          <ListItemIcon>
            <AdminPanelSettingsIcon style={{ color: "red" }} />
          </ListItemIcon>
          <ListItemText primary="Admin Entry" sx={{color: "blue"}}/>
          {openutilities ? (
            <ExpandLess style={{ color: "blue" }} />
          ) : (
            <ExpandMore style={{ color: "blue" }} />
          )}
        </ListItemButton>
  
        <Collapse in={openutilities} timeout="auto" unmountOnExit>
  
        <List component="div" disablePadding sx={{color: "blue"}}>
  
          
        {(urights === 1) && (
              <ListItemButton sx={{ pl: 4 }} 
              onClick={() => handleNavigation("signup")}>
              <ListItemIcon>
                <StarBorder style={{ color: "blue" }} />
              </ListItemIcon>
              <ListItemText primary="Create User" />
            </ListItemButton>
  
            
          )}
  
  
            {(urights === 1) && (
              <ListItemButton sx={{ pl: 4 }} 
              onClick={() => handleNavigation("updateuser")}>
              <ListItemIcon>
                <StarBorder style={{ color: "blue" }} />
              </ListItemIcon>
              <ListItemText primary="Update User" />
            </ListItemButton>
  
            
          )}
  
  
  {(urights === 1) && (
              <ListItemButton sx={{ pl: 4 }} 
              onClick={() => handleNavigation("resetuserpassword")}>
              <ListItemIcon>
                <StarBorder style={{ color: "blue" }} />
              </ListItemIcon>
              <ListItemText primary="Reset User Password" />
            </ListItemButton>
  
            
          )}
  
  {/* {(urights === 1) && (
              <ListItemButton sx={{ pl: 4 }} 
              onClick={() => handleNavigation("newconsignee")}>
              <ListItemIcon>
                <StarBorder style={{ color: "blue" }} />
              </ListItemIcon>
              <ListItemText primary="New Consignee" />
            </ListItemButton>
  
            
          )} */}
  
  
  
  
  {(urights === 1) &&  (
              <ListItemButton sx={{ pl: 4 }} 
              onClick={() => handleNavigation("poExtension")}>
              <ListItemIcon>
                <StarBorder style={{ color: "blue" }} />
              </ListItemIcon>
              <ListItemText primary="Extend DP Date" />
            </ListItemButton>
  
            
          )}

{(urights === 1) && (
              <ListItemButton sx={{ pl: 4 }} 
              onClick={() => handleNavigation("newconsignee")}>
              <ListItemIcon>
                <StarBorder style={{ color: "blue" }} />
              </ListItemIcon>
              <ListItemText primary="New Consignee" />
            </ListItemButton>
  
            
          )}


{/* {(urights === 1) && (
              <ListItemButton sx={{ pl: 4 }} 
              onClick={() => handleNavigation("newconsignee")}>
              <ListItemIcon>
                <StarBorder style={{ color: "green" }} />
              </ListItemIcon>
              <ListItemText primary="Indent Flag Urgent" />
            </ListItemButton>
  
            
          )} */}




     {(urights === 1) && (
              <ListItemButton sx={{ pl: 4 }} 
              onClick={() => handleNavigation("editdata")}>
              <ListItemIcon>
                <StarBorder style={{ color: "blue" }} />
              </ListItemIcon>
              <ListItemText primary="Update Data" style={{ color: "blue" }} />
            </ListItemButton>
  
            
          )}

{(urights === 1) && (
              <ListItemButton sx={{ pl: 4 }} 
              onClick={() => handleNavigation("mergeindent")}>
              <ListItemIcon>
                <StarBorder style={{ color: "blue" }} />
              </ListItemIcon>
              <ListItemText primary="Merge Indent" style={{ color: "blue" }} />
            </ListItemButton>
  
            
          )}


          {/* <ListItemButton
            sx={{ pl: 4 }}
            onClick={() => handleNavigation('changepassword')}
          >
            <ListItemIcon>
              <StarBorder style={{ color: 'blue' }} />
            </ListItemIcon>
            <ListItemText primary="Change Password" />
          </ListItemButton>
        
  
  
            <ListItemButton
              sx={{ pl: 4 }}
              onClick={() => handleNavigation("suggestions")}
            >
              <ListItemIcon>
                <StarBorder style={{ color: "blue" }} />
              </ListItemIcon>
              <ListItemText primary="Help Desk" />
            </ListItemButton> */}
          </List>
        </Collapse>
      </List>
    );
  }

export default MenuAdmin